import './delete-device-modal-container.component.scss';

import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import ModalContainer from '../ModalContainer';
import Button from '../Button';

const DefaultChildren = props => {
  const {
    title,
    description,
    onMoveToInventory,
    onDelete,
    moveToButtonLabel,
    deleteButtonLabel,
  } = props;
  const { t } = useTranslation();

  const currentMoveToButtonLabel = moveToButtonLabel || 'e2e5541dc2' // Move to Inventory;
  const currentDeleteButtonLabel = deleteButtonLabel || '5401a0c19a' // Delete from Organization;

  return (
    <>
      <div className="header">
        <div className="title">{t(title)}</div>
      </div>
      <div className="body">
        <div>
          <p>{description}</p>
        </div>
      </div>
      <div className="footer non-border-top-footer">
        <Button
          label={t(currentMoveToButtonLabel)}
          className="btn-grey"
          onClick={onMoveToInventory}
        />
        <Button
          label={t(currentDeleteButtonLabel)}
          className="btn-grey"
          onClick={onDelete}
        />
      </div>
    </>
  );
};

const DeleteDeviceModalContainer = props => {
  const {
    openModal,
    closeModal,
    onMoveToInventory,
    onDelete,
    modalWidthType,
    title,
    description,
  } = props;

  return (
    <ModalContainer
      openModal={openModal}
      modalWidthType={modalWidthType}
      closeModal={closeModal}
      children={
        <DefaultChildren
          title={title}
          description={description}
          onMoveToInventory={onMoveToInventory}
          onDelete={onDelete}
        />
      }
    />
  );
};

export default memo(DeleteDeviceModalContainer);
